import Service from "../service";
import AuthService from "../AuthService";

const Auth = {
  login(data) {
    return Service.post("/login", data);
  },
  register(data) {
    return Service.post('/register', data);
  },
  getUser() {
    return AuthService.get("/details");
  },
  editUser(data) {
    return AuthService.post('/editUser', data)
  },
  changePassword(data) {
    return AuthService.post('/changePassword', data)
  },
  evaluation(data) {
    return AuthService.post('/save-evaluation', data)
  },
  checkEvaluation(id) {
    return AuthService.get(`/check-evaluation/${id}`)
  },
  requestResetPassword(email) {
    return Service.post('/password/create', email);
  },
  resetPassword(data) {
    return Service.post('/password/reset', data);
  },
  getEmailFromToken(data) {
    return Service.post('/get-email-token', data);
  }
};

export default Auth;
